module.exports = __webpack_public_path__ + "img/vs.c58e1dd4.png";